import { queryConfig } from '../api/queryConfig';
import { SearchableSelect } from './SearchableSelect';

interface Terminal {
  uid: string;
  merchant_name: string;
}

const useTerminals = queryConfig({});

interface Props {
  programUid: string;
  value: string;
  onChange: (value: string) => void;
}

export const TerminalsDropdown = ({ programUid, value, onChange }: Props) => {
  const { data, isLoading } = useTerminals<{ terminals: Terminal[] }>({
    url: `/v1/ops/programs/${programUid}/terminals`,
    cacheKey: `terminals-${programUid}`,
    enabled: programUid !== '',
  });

  const options = (data?.payload?.terminals ?? []).map((terminal) => ({
    value: terminal.uid,
    label: `${terminal.uid.slice(0, 13)} (${terminal.merchant_name})`,
  }));

  return (
    <SearchableSelect
      options={options}
      value={value}
      onChange={onChange}
      placeholder="Select a terminal"
      isLoading={isLoading && programUid !== ''}
    />
  );
};
